import { useTranslation } from 'react-i18next'
import { api } from '../api/client.js'
import { useApi } from '../api/useApi.js'

/** "Recently fed by: Anna 🥣, a friend 🐾, …" — social proof under the feed button. */
export default function RecentFeeders({ slug, version }) {
  const { t } = useTranslation()
  const { data } = useApi(() => api.recentFeeders(slug), [slug, version])
  if (!data?.length) return null
  return (
    <p className="m-0 text-center text-sm text-muted">
      {t('leaderboard.recentlyFed')}{' '}
      {data.map((r, i) => (
        <span key={i} className="font-bold text-ink">
          {i ? ', ' : ''}
          {r.name ?? t('leaderboard.anonymousShort')}
          {r.rank ? ` ${r.rank.emoji}` : ''}
        </span>
      ))}
    </p>
  )
}
